import { render, staticRenderFns } from "./EmailComponent.vue?vue&type=template&id=4bfe1f5a&scoped=true&"
import script from "./EmailComponent.vue?vue&type=script&lang=js&"
export * from "./EmailComponent.vue?vue&type=script&lang=js&"
import style0 from "./EmailComponent.vue?vue&type=style&index=0&id=4bfe1f5a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bfe1f5a",
  null
  
)

export default component.exports